import { apiService } from "../../services/api";

// Action types
export const FETCH_MARGIN_CONFIG_REQUEST = 'FETCH_MARGIN_CONFIG_REQUEST';
export const FETCH_MARGIN_CONFIG_SUCCESS = 'FETCH_MARGIN_CONFIG_SUCCESS';
export const FETCH_MARGIN_CONFIG_FAILURE = 'FETCH_MARGIN_CONFIG_FAILURE';

// Action to fetch margin configuration (with duplicate call prevention)
export const fetchMarginConfigAction = (forceRefresh = false) => async (dispatch, getState) => {
  const state = getState();
  const marginState = state.margin;
  
  // Prevent duplicate calls within 5 minutes unless forced
  const FIVE_MINUTES = 5 * 60 * 1000;
  const now = Date.now();
  const timeSinceLastFetch = now - (marginState.lastFetchTime || 0);
  
  // Skip if already loading
  if (marginState.loading) {
    console.log('Margin config: Already loading, skipping duplicate request');
    return { status: 'loading', message: 'Already loading' };
  }
  
  // Skip if recently fetched and not forcing refresh
  if (!forceRefresh && 
      marginState.marginConfig && 
      Object.keys(marginState.marginConfig).length > 0 && 
      timeSinceLastFetch < FIVE_MINUTES) {
    console.log('Margin config: Using cached data (fetched', Math.round(timeSinceLastFetch / 1000), 'seconds ago)');
    return { status: 'success', data: marginState.marginConfig, cached: true };
  }

  dispatch({
    type: FETCH_MARGIN_CONFIG_REQUEST
  });

  try {
    const response = await apiService.fetchMarginConfig();
    
    if (response.status === 'success') {
      dispatch({
        type: FETCH_MARGIN_CONFIG_SUCCESS,
        payload: response.data
      });
      return { status: 'success', data: response.data };
    } else {
      dispatch({
        type: FETCH_MARGIN_CONFIG_FAILURE,
        payload: response.message || 'Failed to fetch margin configuration'
      });
      return { status: 'error', message: response.message };
    }
  } catch (error) {
    console.error('Margin config fetch error:', error);
    dispatch({
      type: FETCH_MARGIN_CONFIG_FAILURE,
      payload: error.message || 'Failed to fetch margin configuration'
    });
    return { status: 'error', message: error.message };
  }
};

// Action to clear margin config error
export const clearMarginConfigError = () => ({
  type: 'CLEAR_MARGIN_CONFIG_ERROR'
}); 